var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { openModal } from '../open';
import { ResultsModalContent } from './ResultsModalContent';
export const ResultsPropsDummy = () => null;
export const results = (_a) => {
    var { zIndex } = _a, props = __rest(_a, ["zIndex"]);
    const { hide } = openModal({
        header: null,
        footer: null,
        width: 'auto',
        children: _jsx(ResultsModalContent, Object.assign({}, props, { onClose: () => hide() }), void 0),
        okText: '确定',
        zIndex,
        onOk: () => hide(),
    });
    return { hide };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvTW9kYWwvcmVzdWx0cy9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUVuQyxPQUFPLEVBQUUsbUJBQW1CLEVBQWdCLE1BQU0sdUJBQXVCLENBQUE7QUFNekUsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQXFCLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQTtBQUU3RCxNQUFNLENBQUMsTUFBTSxPQUFPLEdBQUcsQ0FBQyxFQUFrQyxFQUFFLEVBQUU7UUFBdEMsRUFBRSxNQUFNLE9BQTBCLEVBQXJCLEtBQUssY0FBbEIsVUFBb0IsQ0FBRjtJQUN4QyxNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsU0FBUyxDQUFDO1FBQ3pCLE1BQU0sRUFBRSxJQUFJO1FBQ1osTUFBTSxFQUFFLElBQUk7UUFDWixLQUFLLEVBQUUsTUFBTTtRQUNiLFFBQVEsRUFBRSxLQUFDLG1CQUFtQixvQkFBSyxLQUFLLElBQUUsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBRSxZQUFJO1FBQ25FLE1BQU0sRUFBRSxJQUFJO1FBQ1osTUFBTTtRQUNOLElBQUksRUFBRSxHQUFHLEVBQUUsQ0FBQyxJQUFJLEVBQUU7S0FDbkIsQ0FBQyxDQUFBO0lBRUYsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFBO0FBQ2pCLENBQUMsQ0FBQSJ9